import React from 'react';
import {DesktopAboutWrapper, MobileAboutWrapper} from './style';

// Component
import Text from 'components/common/Text';
import Image from 'next/image';

// Libs
import Translation from 'libs/Translation';

const About = ({ webConfig }) => {
    const items = [
        {id: 0, title: Translation.t('title.about-item-1'), desc: Translation.t('text.about-item-1')},
        {id: 1, title: Translation.t('title.about-item-2'), desc: Translation.t('text.about-item-2')},
        {id: 2, title: Translation.t('title.about-item-3'), desc: Translation.t('text.about-item-3')},
    ]

    return (
        <>
        <DesktopAboutWrapper>
            <Image
                src="/nextasset/images/home/medical.png"
                alt="about-vclinic"
                width={1440}
                height={1224}
            />
            <div className="text">
                <Text
                    tag="span"
                    className="title"
                >
                    {Translation.t('title.in-vclinic')}
                </Text>
                <Text
                    tag="p"
                    className="desc"
                > 
                    {Translation.t('text.about-home-desc')}  
                </Text>
            </div>
            <div className='desktop-items'>
                {items.map(i => (
                    <div
                        key={i.id}
                        className='item'
                    >
                        <Text
                            tag="h3"
                        >
                            {i.title}
                        </Text>
                        <Text
                            tag="h4"
                        >
                            {i.desc}
                        </Text>
                    </div>
                ))}
            </div>
        </DesktopAboutWrapper>
        <MobileAboutWrapper webConfig={webConfig}>
            <div className="text">
                <Text
                    tag="span"
                    className="title"
                >
                    {Translation.t('title.in-vclinic')}
                </Text>
                <Text
                    tag="p"
                    className="desc"
                > 
                    {Translation.t('text.about-home-desc')}  
                </Text>
            </div>
            <div className='mobile-img'>
                <Image
                    src={webConfig.lang === 'fa' ? "/nextasset/images/home/medical-m.png" : "/nextasset/images/home/medical-m-en.png"}
                    alt="about-vclinic"
                    width={500}
                    height={1212}
                />
            </div>
        </MobileAboutWrapper>
        </>
    )
}

export default About;